import { DeploymentSelectorTabs } from './deployment-selector-tabs';
export default DeploymentSelectorTabs;
